// Outfit selection type indicates whether the outfit pieces were seleted invidiually or as a whole outfit.
export enum OutfitSelectionTypeEnum {
  FULL = 'FULL',
  MIX_AND_MATCH = 'MIX_AND_MATCH',
}
